module.exports = __webpack_public_path__ + "static/img/loginbg-kcc.fe126b25.png";